import { render } from "./Modal.vue?vue&type=template&id=47ad87a4"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=47ad87a4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47ad87a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47ad87a4', __exports__)) {
    api.reload('47ad87a4', __exports__)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=47ad87a4", () => {
    api.rerender('47ad87a4', render)
  })

}


export default __exports__